module.exports = __webpack_public_path__ + "img/visalight.eb056cd0f1b3.svg";